export enum WeightMetricUnitsEnum {
    gram = "G",
    kg = "KG",
    //...
}
